import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { reduceLayerTwoData } from 'helpers/data';
import RenderingTile from 'components/molecules/RenderingTile';
import VideoQuartileChart from 'components/molecules/charts/VideoQuartileChart';
import VideoCompletionRateChart from 'components/molecules/charts/VideoCompletionRateChart';
import SocialAdSetOverviewPivotTable from 'components/molecules/tables/SocialAdSetOverviewPivotTable';
import SocialConversionsChart from 'components/molecules/charts/SocialConversionsChart';
import { LAYERTHREE, LAYERTWO } from 'constants/layers';
import { getActivitiesSettings } from 'helpers/objectiveSettings';

// LayerTwo Charts & Tables
import LayerTwoSummaryTable from 'components/molecules/tables/LayerTwoSummaryTable';
import SocialActionOverviewTable from 'components/molecules/tables/SocialActionOverviewTable';

class VideoViewsExpandModule extends Component {
    render() {
        const {
            backfillBuckets,
            layer = LAYERTHREE,
            layerTwo,
            showConversionRevenue,
            entityMeta,
            entityObjective,
            entityObjectiveLabelCode
        } = this.props;
        const {
            conversionTermSingular,
        } = getActivitiesSettings(entityObjective, entityObjectiveLabelCode);
        const { adsets, campaigns, timeData, actions } = this.props.module;
        const stub = `l${layer}-social`;
        const hasAdSetData = get(adsets, 'hasData', null);
        const hasTimeData = get(timeData, 'hasData', null);
        const l2Data = get(layerTwo, 'social', {});
        const hasLayerTwoSummaryData = get(l2Data, 'summary.hasData', null);
        const aliasDescriptor = get(this.props, 'entityMeta.childAliasNames.pick', 'LOCATION');
        const userId = get(this.props, 'currentUser.id', null);
        const entityId = get(this.props, 'entityId', null);


        let childSummaryTableData = [];
        if (hasLayerTwoSummaryData) {
            const reducedData = reduceLayerTwoData(l2Data.summary);
            childSummaryTableData = reducedData.childSummaryTableData;
        }

        const objectives = get(entityMeta, 'social.objectives', []);
        const showLayerTwoSummaryTable = !!(hasLayerTwoSummaryData && (layer === LAYERTWO) && (objectives.length > 1));
        const showCampaignSummaryTable = !!(hasAdSetData && layer === LAYERTHREE);

        const layerTwoSummaryAccessors = ['impressions', 'clicks', 'cpc', 'link_clicks', 'cost_per_link_click', 'conversions', 'conversion_rate', 'engagements', 'engagement_rate', 'spend'];

        return (
            <React.Fragment>
                {hasTimeData ? (
                    <VideoCompletionRateChart
                        title="COMPLETION RATE TRENDS"
                        exportName={`${stub}-video-views-completion-rate-trends`}
                        data={timeData.data}
                        backfillBuckets={backfillBuckets}
                        animateDuration={2000}
                        yAxisLabel='COMPLETION RATE' />
                ) : (
                    <RenderingTile height='400px' show={hasTimeData} />
                )}

                {hasTimeData ? (
                    <VideoQuartileChart
                        title="COMPLETION QUARTILES"
                        exportName={`${stub}-video-views-completion-quartiles`}
                        data={timeData.data}
                        backfillBuckets={backfillBuckets}
                        social={true}
                        animateDuration={2000}
                        yAxisLabel='COMPLETION QUARTILES' />
                ) : (
                    <RenderingTile height='400px' show={hasTimeData} />
                )}

                <SocialConversionsChart actions={actions} exportNamePrefix={`${stub}-video-views`} />

                {showLayerTwoSummaryTable ? (
                    <LayerTwoSummaryTable
                        title={`${aliasDescriptor} OVERVIEW`}
                        channel={'social'}
                        showConversionRevenue={showConversionRevenue}
                        aliasDescriptor={aliasDescriptor}
                        data={childSummaryTableData}
                        exportName={`${stub}-video-views-table-performance`}
                        accessors={layerTwoSummaryAccessors}
                        cacheKey={`${stub}-video-views-table-performance-${userId}-${entityId}`}
                    />
                ) : (
                    <RenderingTile height='400px' show={showLayerTwoSummaryTable} />
                )}

                {showCampaignSummaryTable ? (
                    <SocialAdSetOverviewPivotTable
                        title="Campaign Overview"
                        exportName={`${stub}-video-views-summary-adsets-overview`}
                        adSets={adsets}
                        showConversionRevenue={showConversionRevenue}
                    />
                ) : (
                    <RenderingTile height='400px' show={showCampaignSummaryTable} />
                )}

                <SocialActionOverviewTable
                    exportName={`${stub}-video-views-action-overview`}
                    actions={actions}
                    campaigns={campaigns}
                    conversionTermSingular={conversionTermSingular}
                    cacheKye={`${stub}-video-views-action-overview-${userId}-${entityId}`}
                />
            </React.Fragment>
        );
    }
}

VideoViewsExpandModule.propTypes = {
    module: PropTypes.shape({
        actions: PropTypes.object,
        callouts: PropTypes.object,
        campaigns: PropTypes.object,
        timeData: PropTypes.object
    }).isRequired
};

export default VideoViewsExpandModule;



// WEBPACK FOOTER //
// ./src/components/organisms/social/VideoViewsExpandModule.js